var map = {
	"./Taco-Loca-tor.png": 33,
	"./boids-quadtree.gif": 817,
	"./brass-knuckles.png": 494,
	"./budget-tracker.png": 90,
	"./composite.png": 104,
	"./photography-portfolio.png": 255,
	"./raycasting-demo.gif": 167,
	"./resource-calc.png": 342,
	"./resume.png": 754,
	"./still-good.png": 882,
	"./tj-headshot.png": 741,
	"./work-it-done.png": 561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;